const translatePercentageToScreenPixels = (percentageX: number, percentageY: number) => {
  const totalWidth = document.body.scrollWidth;
  const totalHeight = document.body.scrollHeight;

  const x = totalWidth / 100 * percentageX
  const y = totalHeight / 100 * percentageY

  return { x, y }
}
export default translatePercentageToScreenPixels;